type Props = {
  outcome: string;
  amount: number;
};

const SingleChip = ({ outcome, amount }: Props) => {
  return (
    <img
      className={`chip chip--${outcome}`}
      src={`/images/chips/chip-${amount}.svg`}
      alt={`${amount} chip`}
    />
  );
};

export default SingleChip;
